<template>
  <v-card class="max-shadow">
    <v-card-title primary-title>
      <div class="headline">
        Add Printer
      </div>
    </v-card-title>
    <v-card-text>
      <v-form
        ref="addPrinterForm"
      >
        <v-container
          grid-list-lg
          fluid
          class="pa-3"
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              sm6
            >
              <v-text-field
                v-model="device.name"
                :rules="[v => !!v || 'Name is required']"
                name="name"
                label="Name" 
              />
            </v-flex>
            <v-flex
              xs12
              sm6
            >
              <v-select
                v-model="device.model"
                :items="printerModels"
                :rules="[v => !!v || 'Model is required']"
                label="Select Printer Model"
              />
            </v-flex>
            <template v-if="device.model">
              <template v-if="device.model === 'QL-820NWB'">
                <v-flex
                  xs12
                  sm6
                >
                  <p class="subheading mb-0">
                    Connectivity Interface
                  </p>
                  <v-radio-group
                    v-model="device.interface"
                    :rules="[v => !!v || 'Connectivity type is required for the selected printer']"
                    row
                  >
                    <v-radio
                      label="Bluetooth"
                      value="BLUETOOTH"
                      color="primary" 
                    />
                    <v-radio
                      label="Wifi"
                      value="WIFI"
                      color="primary" 
                    />
                  </v-radio-group>
                </v-flex>
                <template v-if="device.interface === 'BLUETOOTH'">
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      v-model="device.bmac"
                      :rules="[v => {return validateMac(v, 'required')}]"
                      :validate-on-blur="true"
                      label="Bluetooth MAC Address"
                      return-masked-value
                      mask="NN:NN:NN:NN:NN:NN"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-select
                      v-model="selectedKiosk"
                      :items="blutoothUnpairedKiosks"
                      label="Choose a Kiosk"
                      :rules="[v => !!v || 'Kiosk is required']"
                      return-object
                      item-text="name"
                      item-value="id"
                      clearable
                      hint="Selected kiosk gets paired with the printer"
                      persistent-hint
                    />
                  </v-flex>
                </template>
              </template>
              <template v-if="device.model !== 'QL-820NWB' || device.interface === 'WIFI'">
                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="device.ip"
                    :rules="[v => !!v || 'IP Address is required', v => ipRegex.test(v) || 'Invalid IP Address' ]"
                    :validate-on-blur="true"
                    label="IP Address"
                    placeholder="106.51.36.97"
                  />
                </v-flex>
              </template>
              <template v-if="device.interface === 'WIFI' || device.model !== 'QL-820NWB'">
                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="device.wmac"
                    :rules="[v => {return validateMac(v, 'notrequired')}]"
                    :validate-on-blur="true"
                    :class="{addNegMargin:(device.model === 'QL-820NWB' && device.interface === 'WIFI')}"
                    label="Wifi MAC Address"
                    return-masked-value
                    mask="NN:NN:NN:NN:NN:NN"
                  />
                </v-flex>
              </template>
            </template>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        flat
        color="primary"
        :disabled="loading"
        @click.stop="$emit('closeDialog'); $refs.addPrinterForm.reset()"
      >
        Cancel
      </v-btn>
      <v-btn
        flat
        color="primary"
        :loading="loading"
        @click.stop="addPrinter"
      >
        add
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import _get from 'lodash/get';
import { database } from '@/firebase';
export default {
  name: 'AddPrinter',
  props: {
    kiosks: {
      type: Array,
      default: () => [],
      required: true
    },
    printers: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      device: {},
      blutoothUnpairedKiosks: [],
      ipRegex: /^\b(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\b$/,
      printerModels: ['QL-820NWB', 'QL-720NW'],
      selectedKiosk: {},
      loading: false
    };
  },
  computed: {
    deviceRef() {
      const lid = _get(this.$store.state.VMS, 'lid');
      // return null if the location ID is not yet set
      if (!lid) return null;

      return database.ref(`vms/devices`);
    }
  },
  watch: {
    kiosks: {
      handler(val) {
        if (!val) return;
        val.forEach(kiosk => {
          const printers = _get(kiosk, printers, []);
          let hasBluetoothPrinter = false;
          if (printers.length > 0) {
            printers.forEach(pid => {
              if (this.printers[pid].interface === 'BLUTOOTH')
                return (hasBluetoothPrinter = true);
            });
          }
          if (hasBluetoothPrinter) return;
          this.blutoothUnpairedKiosks.push(kiosk);
        });
      },
      immediate: true
    }
  },
  methods: {
    validateMac(val, type) {
      let duplicate = false;
      if (type === 'notrequired' && val) {
        if (/^([0-9a-f]{2}([:-]|$)){6}$|([0-9a-f]{4}([.]|$)){3}$/i.test(val)) {
          this.printers.forEach(printer => {
            if (printer.wmac && printer.wmac === val) duplicate = true;
          });
          if (!duplicate) return true;
          return 'Duplication MAC Address';
        }
        return 'MAC is invlaid';
      } else if (type === 'required') {
        if (val) {
          if (
            /^([0-9a-f]{2}([:-]|$)){6}$|([0-9a-f]{4}([.]|$)){3}$/i.test(val)
          ) {
            this.printers.forEach(printer => {
              if (printer.bmac && printer.bmac === val) duplicate = true;
            });
            if (!duplicate) return true;
            return 'Duplicate MAC Address';
          }
          return 'Mac is invalid';
        }
        return 'Mac is required';
      }
      return true;
    },
    addPrinter() {
      if (this.$refs.addPrinterForm.validate()) {
        this.loading = true;
        this.$emit('persistDialog');
        let device = {};
        if (this.device.interface === 'BLUETOOTH') {
          const kiosks = [`${this.selectedKiosk.id}`];
          device = {
            name: this.device.name,
            model: this.device.model,
            interface: this.device.interface,
            bmac: this.device.bmac,
            lid: this.$store.state.VMS.lid,
            deviceOS: 'PRINTER',
            location: 'Towers Max',
            type: 'Printer',
            kiosks: kiosks,
            status: 'offline'
          };
        } else {
          device = {
            name: this.device.name,
            model: this.device.model,
            interface: 'WIFI',
            wmac: this.device.wmac || null,
            ip: this.device.ip,
            lid: this.$store.state.VMS.lid,
            deviceOS: 'PRINTER',
            location: 'Towers Max',
            type: 'Printer',
            status: 'offline'
          };
        }
        this.deviceRef
          .push(device)
          .then(() => {
            this.$emit('closeDialog');
            this.$refs.addPrinterForm.reset();
            this.$emit('success', 'Printer has been added successfully');
            this.loading = false;
          })
          .catch(err => {
            this.$emit('error', err);
            this.$emit('closeDialog');
            this.$refs.addPrinterForm.reset();
            this.loading = false;
          });
      }
    }
  }
};
</script>
